module.exports = __webpack_public_path__ + "static/media/nation-safe-drivers.c04575e4.png";